var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgG2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.619 0H.381v12.19L7.619 16l8-3.81V0zM9.87 9.744l1.03 1.786c-1.513 1.159-3.867 1.299-5.61-.035A4.693 4.693 0 014.03 5.45C5.263 3.28 7.574 2.8 9.061 3.152c-.04.088-.93 1.936-.93 1.936s-.071.005-.111.006c-.44.018-.767.12-1.118.302A2.66 2.66 0 005.49 7.45c-.052.437.008.88.176 1.289.14.344.34.65.609.91.411.396.9.642 1.468.723a2.55 2.55 0 001.538-.242 3.126 3.126 0 00.56-.363l.028-.023zm.004-5.262l-.076-.074-.174-.172-.055-.055a3.25 3.25 0 00-.09-.09c-.018-.016-.038-.04-.038-.04l.024-.05c.094-.19.243-.329.419-.44.195-.122.422-.185.652-.18.295.007.569.08.8.278.17.146.258.33.274.552.025.372-.129.658-.435.857-.122.08-.25.146-.38.214-.062.033-.126.066-.189.101-.107.06-.199.112-.304.219a.379.379 0 00-.097.209l1.395-.002v.621H9.447v-.06c-.008-.305.028-.592.168-.87.128-.254.328-.44.568-.583.094-.056.19-.108.287-.16.093-.05.186-.1.277-.154.115-.068.196-.168.195-.312a.284.284 0 00-.219-.268.678.678 0 00-.772.327l-.043.074-.034.058zm1.522 2.573l1.175 2.03-1.185 2.04-1.156-2.02H7.888l1.182-2.05h2.326z",
    fill: "#FF492C"
  })));
}

export default __webpack_public_path__ + "./fonts/g2-icon.6b4b1eb1d8d6c935715e4c4c852438c4.svg";
export { SvgG2Icon as ReactComponent };